import type { ReactNode } from 'react';
import { Link } from 'react-router-dom';

import { Button } from '@/modules/ui/components/button/Button';
import { Card, CardContent } from '@/modules/ui/components/card/Card';
import { Paragraph } from '@/modules/ui/components/paragraph/Paragraph';
import { Subheading } from '@/modules/ui/components/subheading/Subheading';

interface EmptyStateProps {
  title: string;
  description?: string;
  icon?: ReactNode;
  action?: {
    label: string;
    href?: string;
    onClick?: () => void;
  };
}

export function EmptyState({
  title,
  description,
  icon,
  action,
}: EmptyStateProps) {
  return (
    <Card className="flex h-full min-h-[400px] items-center justify-center">
      <CardContent className="flex flex-col items-center justify-center gap-4 text-center">
        {icon && <div className="text-muted-foreground">{icon}</div>}

        <div className="flex flex-col gap-2">
          <Subheading variant="h4" className="text-foreground">
            {title}
          </Subheading>

          {description && (
            <Paragraph variant="body" className="text-muted-foreground">
              {description}
            </Paragraph>
          )}
        </div>

        {action && (
          <>
            {action.href ? (
              <Button asChild>
                <Link to={action.href}>{action.label}</Link>
              </Button>
            ) : (
              <Button onClick={action.onClick}>{action.label}</Button>
            )}
          </>
        )}
      </CardContent>
    </Card>
  );
}
